import React, { useRef, useState, useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

import { Button, Input, Spinner } from 'src/UIComponents';
import { createAnything, uploadImage } from 'src/api-services';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

function AnythingUploadImage({ somethingId, onComplete, ...rest }) {
  const imagesRef = useRef();
  const [formFile, setFormFile] = useState(null);
  const [isUploading, setUploading] = useState(false);

  const { mutate: newAnything, isLoading: isCreatingAnything } = useMutation(
    createAnything,
    {
      onSuccess: ({ data: createdItem }) => {
        setFormFile(null);
        onComplete(createdItem);
      },
    }
  );

  const postFile = useCallback(async () => {
    if (isUploading) {
      return;
    }
    setUploading(true);
    const response = await uploadImage({
      image: formFile,
    });
    setUploading(false);

    if (response.status !== 200) {
      console.error('Failed to upload image: ', response);
      return;
    }
    const {
      data: { fileKey: extendedFileKey },
    } = response;

    newAnything({
      type: 'IMAGE_S3',
      value1: extendedFileKey, // prefixed with generated UUID
      value2: formFile.name, // original name
      SomethingId: somethingId,
    });
  }, [isUploading, formFile, somethingId, newAnything]);

  const onFileChange = useCallback((event) => {
    const files = event.target.files;
    const singleFile = files[0];
    setFormFile(singleFile);
  }, []);

  return (
    <Container {...rest}>
      <Input
        ref={imagesRef}
        type="file"
        label="Upload"
        accept="image/*"
        onChange={onFileChange}
        multiple
        block
      />

      <Button
        $color="primary"
        onClick={postFile}
        disabled={isUploading || isCreatingAnything || !formFile}
      >
        {isUploading || isCreatingAnything ? <Spinner /> : 'Upload'}
      </Button>
    </Container>
  );
}

AnythingUploadImage.defaultProps = {
  onComplete: () => {},
};

AnythingUploadImage.propTypes = {
  onComplete: PropTypes.func,
};

export default AnythingUploadImage;
